import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserAuth } from '../../../../../context/AuthContext';
import { StepForm2 } from './Step2Form';
import { StepForm4 } from './Step4Form';
import { Swiper, SwiperSlide } from 'swiper/react';
//import { SecurityTSL } from '../../components/SignUpLayout';
import { useLucaAuth } from '../hooks/useAuth';
import '../part1/SignUpLayout.css'

// step forms accountProfile sign up
const stepForms = [
  <StepForm2 key={1} />,
  //<StepForm3 key={2} />,
  <StepForm4 key={2} />,
]

const stepTitles = [
  {title: 'Conecta tu empresa a TryLuca',subtitle: 'Define el nombre de la organización que agrupará tus empresas en TryLuca.',},
  //{title: 'Conecta tu empresa a TryLuca',subtitle: 'Selecciona tu rol para personalizar tu experiencia en la plataforma.',},
  {title: 'Conecta tu empresa a TryLuca',subtitle: 'Conecta tu empresa con el SII para importar automáticamente tu información tributaria.',},
]

const steps = [
  "Organización",
  //"Rol",
  "Conexión SII"
]

export const CompleteSignUp: FC = () => {
  const navigate = useNavigate()
  const { apiToken } = useLucaAuth((state) => state.accountProfile)
  const { user, isLoaded } = UserAuth()
  const [activeIndex, setActiveIndex] = useState(0)

  useEffect(() => {
    if (!user && !apiToken && isLoaded) {
      navigate('/auth/signup?', { replace: true })
    }
    console.log(activeIndex)
  }, [user, apiToken, isLoaded, navigate])
  return (
    <div className='signup-wrapper flex w-full min-h-screen justify-center items-center px-4 sm:px-6'>
      <div className='flex flex-col items-center w-full max-w-xl lg:max-w-2xl xl:max-w-3xl'>
        <div className="signup-section flex items-center justify-center gap-4 mb-6">
          {steps.map((step, index) => (
            <div key={index} className="flex items-center gap-2">

              <div
                className={`w-9 h-9 flex items-center justify-center rounded-full text-sm font-semibold
                ${activeIndex >= index
                  ? "bg-primary text-white"
                  : "bg-gray-200 text-gray-500"}`}
              >
                {index + 1}
              </div>

              <span
                className={`text-sm hidden sm:block
                ${activeIndex >= index
                  ? "text-primary"
                  : "text-gray-400"}`}
              >
                {step}
              </span>

              {index < steps.length - 1 && (
                <div className="w-8 h-[2px] bg-gray-300" />
              )}
            </div>
          ))}
        </div>
        {/* TITULO */}
        <h2 className='signup-title text-2xl sm:text-3xl font-bold mb-2 text-center text-primary'>
          {stepTitles[activeIndex].title}
        </h2>

        {/* SUBTITULO */}
        {stepTitles[activeIndex].subtitle && (
          <p className='signup-subtitle text-sm text-center mb-6 max-w-xl leading-relaxed text-gray-600'>
            {stepTitles[activeIndex].subtitle}
          </p>
        )}

        {/* CARD FORMULARIO */}
        <div className="signup-container relative w-full max-w-xl p-8 bg-white rounded-2xl shadow-lg border border-gray-100">

          <Swiper
            className='signup-swiper'
            onSlideChange={(sw) => setActiveIndex(sw?.activeIndex)}
            spaceBetween={30}
            autoHeight
            allowTouchMove={false}
          >
            {stepForms.map((step, index) => (
              <SwiperSlide key={index}>
                {step}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
            
          <p className='signup-footer text-center font-sans text-xs mt-2'>
            En caso de problemas, contactate con el equipo a{' '}
            <span className='text-accent1 font-sans text-xs'>soporte@tryluca.cl</span>
          </p>
        
      </div>
    </div>
  )
}
